export default "__VITE_ASSET__688e150c__"